import { EmbedComponent } from "./embed-component";

window.EmbedComponent = EmbedComponent;
